import React from 'react';
import SEO from '../../common/SEO';
import WILBanner from '../../components/programs-section/WILBanner';
import WILAbout from '../../components/programs-section/WILAbout';
import WILBusinesses from '../../components/programs-section/WILBusinesses';
import IndustryPartnerWIL from '../../components/programs-section/IndustryPartnerWIL';
import WILFooter from '../../components/programs-section/WILFooter';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';
import WILWorkforceDevelopment from '../../components/programs-section/WILWorkforceDevelopment';

const WorkIntegratedLearning = () => {
  return (
    <>
      <SEO
        title="Industry Partner Work Integrated Learning"
        description="Prepare yourself for a successful career by joining our program and unlocking the power of experiential learning."
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <WILBanner />
      <WILAbout />
      <WILWorkforceDevelopment />
      <WILBusinesses />
      <IndustryPartnerWIL />
      <WILFooter />
      <FooterOne />
    </>
  )
}
export default WorkIntegratedLearning;